/* Homepage parallax backgrounds (Oct 2026). Loaded on the homepage only from head-tag.liquid.
   The background photo moves slower than the page as you scroll, so it drifts behind the section's content.
   Sections (homepage template section IDs):
   - "Are you a stylist? Join our wholesale program." (Image with text overlay): the photo layer is .rimage-background
   - "I get compliments everywhere I go." Six eau de parfum (Image with text, background image): the section's own
     CSS background is moved onto a layer inside it so it can move without moving the content.
   The photo is drawn 20% taller than the section and travels up to 10% of the section height either way, so its edges
   never show. Turned off for visitors who ask their device for reduced motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var WHOLESALE = '#shopify-section-template--28845916717332__image_with_text_overlay_XDBNtB';
  var PERFUME = '#section-template--28845916717332__image_with_text_bg_mnwfgn';
  var RANGE = 0.1; // share of the section height the photo can travel each way

  var items = [];

  var css = document.createElement('style');
  css.textContent =
    WHOLESALE + ' .rimage-background-wrapper{overflow:hidden;position:relative}' +
    WHOLESALE + ' .rimage-background{will-change:transform;transform-origin:50% 50%}' +
    '.pbg-host{position:relative;overflow:hidden;background-image:none !important}' +
    '.pbg-host > :not(.pbg-layer){position:relative;z-index:1}' +
    '.pbg-layer{position:absolute;left:0;right:0;top:-10%;bottom:-10%;z-index:0;background-size:cover;background-position:center;background-repeat:no-repeat;will-change:transform;pointer-events:none}';
  document.head.appendChild(css);

  function setupWholesale() {
    var section = document.querySelector(WHOLESALE);
    if (!section) return;
    section.querySelectorAll('.rimage-background').forEach(function (el) {
      items.push({ box: section.querySelector('.rimage-background-wrapper') || section, move: el, scale: 1 + RANGE * 2 });
    });
  }

  function perfumeBg(host) {
    host.classList.remove('pbg-host');
    var bg = getComputedStyle(host).backgroundImage;
    host.classList.add('pbg-host');
    return bg;
  }

  function setupPerfume() {
    var host = document.querySelector(PERFUME);
    if (!host) return;
    var bg = getComputedStyle(host).backgroundImage;
    if (!bg || bg === 'none') return;
    var layer = document.createElement('div');
    layer.className = 'pbg-layer';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.backgroundImage = bg;
    host.insertBefore(layer, host.firstChild);
    host.classList.add('pbg-host');
    items.push({ box: host, move: layer, scale: 1, host: host });
    // Desktop and mobile use different photos: refresh the layer's photo when the screen size changes.
    var last = window.innerWidth >= 768;
    window.addEventListener('resize', function () {
      var now = window.innerWidth >= 768;
      if (now !== last) { last = now; layer.style.backgroundImage = perfumeBg(host); }
    });
  }

  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    items.forEach(function (it) {
      var r = it.box.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      // -1 when the section's center is at the bottom of the screen, +1 at the top
      var p = ((vh / 2) - (r.top + r.height / 2)) / (vh / 2 + r.height / 2);
      if (p > 1) p = 1; if (p < -1) p = -1;
      var y = p * r.height * RANGE;
      it.move.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)' + (it.scale !== 1 ? ' scale(' + it.scale + ')' : '');
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  function init() {
    setupWholesale();
    setupPerfume();
    if (!items.length) return;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
